document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.product__inventory').forEach(inv => {
    const circles = inv.querySelectorAll('svg.icon-inventory-status circle');
    if (!circles || circles.length === 0) return;

    const text = inv.textContent.trim().toLowerCase();

    if (text.includes("in stock")) {
      circles.forEach(circle => circle.setAttribute('fill', '#16a34a')); // green
    } else if (text.includes("out of stock")) {
      circles.forEach(circle => circle.setAttribute('fill', '#dc2626')); // red
    } else {
      circles.forEach(circle => circle.style.display = 'none'); // hide low stock/orange
    }
  });
});